import Hero from "../components/Hero";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
    </div>
  );
}
